import { Component, ElementRef, ViewChild } from '@angular/core';
import { BrasilApiService } from '../../services/brasil-api.service';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-validacao-plano-saude-instituto',
  templateUrl: './modal-validacao-plano-saude-instituto.component.html',
  styleUrls: ['./modal-validacao-plano-saude-instituto.component.css']
})
export class ModalValidacaoPlanoSaudeInstitutoComponent {

  @ViewChild('artigoSaude', {static: false}) textoGrandeElement!: ElementRef;

  aceite: boolean = false;

  constructor(public activeModal: NgbActiveModal, private formBuilder:FormBuilder, private brasilApiService:BrasilApiService){
    this.scrollParaTopo();
  }

  scrollParaTopo() {
    if (this.textoGrandeElement) {
      this.textoGrandeElement.nativeElement.scrollTop = 0;
    }
  }

  salvar(){
    this.activeModal.close();
  }
  

}
